import '../../css/style.scss'
import '../../css/leaderboard.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {Sound} from '../../../shared/scripts/Sound'
import {UIMinimalHeaderController} from '../ui_html/new_layout/UIMinimalHeaderController'
import {UISidebarController} from '../ui_html/new_layout/UISidebarController'
import {UIWLeaderboardController} from './UIWLeaderboardController'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'

void init()

async function init() {
    Sound.loadSounds()

    await EntryShared.initializeEntry()

    const headerController = new UIMinimalHeaderController()
    new UISidebarController()

    new UIWLeaderboardController()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
